exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-card__text[data-v-019ffe33]{\n  font-size:14px;\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports
